import { z } from 'zod';
import { request, useQuery } from '@applyboard/ui-utils';

const RawProgramSchema = z.object({
  data: z.array(
    z.object({
      id: z.string(),
      type: z.literal('program'),
      attributes: z.object({
        name: z.string(),
      }),
    }),
  ),
});

export type RawPrograms = z.infer<typeof RawProgramSchema>;

export interface useGetProgramsProps {
  schoolId: string;
  name: string;
}

export function useGetProgramNames(
  { schoolId, name }: useGetProgramsProps,
  {
    enabled,
    retryCount,
    retryOnMount,
  }: { enabled?: boolean; retryCount?: number; retryOnMount?: boolean } = { retryCount: 2 },
) {
  const { isLoading, isFetching, error, data } = useQuery(
    ['useGetProgramNames', name, schoolId, { pkg: 'ab-vas-gic' }],
    async () => {
      const response = await request<RawPrograms>(
        `/api/v2/programs?filter[school][id]=${schoolId}&filter[q]=${name}&fields[program]=name`,
        {
          schema: RawProgramSchema,
          allowAnonymous: true,
        },
      );

      return (
        response?.data.map(program => ({
          id: program.id,
          ...program.attributes,
        })) ?? []
      );
    },
    {
      enabled: enabled,
      refetchOnMount: false,
      retryOnMount: retryOnMount,
      retry: retryCount,
    },
  );

  return {
    programs: data,
    programsError: error,
    isLoadingPrograms: isLoading,
    isFetchingPrograms: isFetching,
  };
}
